<div *ngFor="let alert of sortedAlerts()" [ngClass]="cssClass(alert)" class="alert-item">
  <div [innerHTML]="alert.message"></div>

  <button *ngIf="alert.closeable" type="button" (click)="removeAlert(alert)">Close</button>
</div>
